<template>
  <svg
    v-if="negative"
    :width="width"
    :height="height"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="1.04346" width="24" height="21.913" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6078 1.26329V22.5171L0.971432 20.3265V3.45389L13.6078 1.26329ZM14.2082 3.71684H22.6C23.0638 3.71684 23.1528 3.80795 23.1528 4.26967V19.5086C23.1528 19.9703 23.0638 20.0615 22.6 20.0615H14.2082V18.6245H17.4113V16.4174H14.2082V15.7548H17.4113V13.5456H14.2082V12.883H17.4113V10.6738H14.2082V10.0112H17.4113V7.80403H14.2082V7.14147H17.4113V4.93223H14.2082V3.71684ZM0 22.9565H24V0H12.5217H0V22.9565Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.49982 7.94482L7.34862 10.5785L6.45416 8.10425L5.01516 8.16844L6.44381 11.7732L4.83502 15.2993L6.24918 15.4049L7.38382 12.8685L8.43978 15.5519L10.0672 15.6409L8.30313 11.7587L9.99059 7.83716L8.49982 7.94482Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0739 18.6245H21.718V16.4174H18.0739V18.6245Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0739 15.7549H21.718V13.5457H18.0739V15.7549Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0739 12.8829H21.718V10.6737H18.0739V12.8829Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0739 7.14149H21.718V4.93225H18.0739V7.14149Z"
      fill="#1E7145"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0739 10.0112H21.718V7.80408H18.0739V10.0112Z"
      fill="#1E7145"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 48.387 47.271"
  >
    <g data-name="microsoft excel">
      <path
        fill="#1E7145"
        d="M25.306,0h3.265V4.4c5.5,0,11,.011,16.506-.017a5.06,5.06,0,0,1,2.759.528,5.046,5.046,0,0,1,.539,2.781Q48.334,22,48.365,36.3a25.1,25.1,0,0,1-.187,4.81c-.22,1.143-1.594,1.171-2.512,1.209-5.694.016-11.394-.011-17.094,0v4.947H25.158C16.781,45.748,8.387,44.341,0,42.873V4.4C8.437,2.935,16.874,1.49,25.306,0Z"
        data-name="Path 16"
      />
      <path
        fill="#fff"
        d="M64.975,13.75H83.114V48.378H64.975v-3.3h4.4V41.233h-4.4v-2.2h4.4V35.187h-4.4v-2.2h4.4V29.14h-4.4v-2.2h4.4V23.094h-4.4V20.9h4.4V17.048h-4.4Z"
        data-name="Path 17"
        transform="translate(-36.404 -7.704)"
      />
      <path
        fill="#1E7145"
        d="M79.975,21.25h7.7V25.1h-7.7Z"
        data-name="Path 18"
        transform="translate(-44.808 -11.906)"
      />
      <path
        fill="#fff"
        d="M25.407,32.675q1.863-.132,3.738-.225-2.2,4.514-4.435,9.009c1.512,3.078,3.056,6.134,4.573,9.212q-1.985-.114-3.968-.253a64.89,64.89,0,0,1-2.743-6.9c-.747,2.232-1.814,4.337-2.671,6.525-1.2-.017-2.408-.066-3.611-.116,1.412-2.765,2.776-5.552,4.232-8.3-1.237-2.831-2.594-5.607-3.87-8.421q1.814-.108,3.628-.209c.819,2.149,1.714,4.271,2.391,6.475.725-2.336,1.808-4.534,2.737-6.794Z"
        data-name="Path 19"
        transform="translate(-9.126 -18.181)"
      />
      <path
        fill="#1E7145"
        d="M79.975,35h7.7v3.848h-7.7Zm0,6.046h7.7v3.848h-7.7Zm0,6.046h7.7V50.94h-7.7Zm0,6.046h7.7v3.848h-7.7Z"
        data-name="Path 20"
        transform="translate(-44.808 -19.61)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconExcel',
  props: {
    width: {
      type: Number,
      default: 23,
    },
    height: {
      type: Number,
      default: 27,
    },
    negative: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
</style>